(function() {
	var getState = gantt.getState;
	gantt.getState = function () {
		var state = getState.apply(this, arguments);
		state.fullscreen = isExpanded();
		return state;
	};

	function isExpanded(){
		var element = (document.fullscreenElement ||
			document.mozFullScreenElement ||
			document.webkitFullscreenElement ||
			document.msFullscreenElement);

		return element && element === document.body;
	}

	function isFullscreenAvailable(){
		return document.fullscreenEnabled ||
		document.webkitFullscreenEnabled ||
		document.mozFullScreenEnabled ||
		document.msFullscreenEnabled;
	}

	var expanded = false;

	var backupElementSizes = {
		width:null,
		height:null,
		top:null,
		position:null,
		modified: false
	};

	// expand gantt root element to fullscreen automatically
	function setFullScreenSizes(){
		var root = gantt.$root;
		backupElementSizes.width = root.style.width;
		backupElementSizes.height = root.style.height;
		backupElementSizes.top = root.style.top;
		backupElementSizes.position = root.style.position;
		root.style.width = '100vw';
		root.style.height = '100vh';
		root.style.top = '0';
		root.style.position = 'absolute';
		backupElementSizes.modified = true;
	}

	function setNotFullScreenSizes(){
		var root = gantt.$root;
		if(backupElementSizes.modified){
			root.style.width = backupElementSizes.width;
			root.style.height = backupElementSizes.height;
			root.style.top = backupElementSizes.top;
			root.style.position = backupElementSizes.position;
			backupElementSizes.modified = false;
		}
	}

	function prepareGanttContainer(isGanttExpanded){
		if(isGanttExpanded){
			setFullScreenSizes();
			setTimeout(function(){
				gantt.render();
			});
		}
		else {
			setNotFullScreenSizes();
			gantt.render();
		}
	}

	function onFullScreenChange() {
		if(!gantt.$container){
			// do nothing if gantt is not yet initialized
			return;
		}

		var isGanttExpanded = isExpanded();
		prepareGanttContainer(isGanttExpanded);
		if(isGanttExpanded){
			expanded = true;
			setTimeout(function(){
				gantt.callEvent("onExpand");
			});
		}else if (expanded){
			expanded = false;
			setTimeout(function(){
				gantt.callEvent("onCollapse");
			});
		}
	}

	function addDOMEvents(){
		gantt.event(document, "webkitfullscreenchange", onFullScreenChange);
		gantt.event(document, "mozfullscreenchange", onFullScreenChange);
		gantt.event(document, "MSFullscreenChange", onFullScreenChange);
		//For IE on Win 10
		gantt.event(document, "fullscreenChange", onFullScreenChange);
		gantt.event(document, "fullscreenchange", onFullScreenChange);
	}	
	gantt.attachEvent("onGanttReady", addDOMEvents);

	function cantFullscreen(){
		if(!gantt.$container){
			return true;
		}
		if(!isFullscreenAvailable()){
			// eslint-disable-next-line no-console
			var method = console.warning || console.log;
			method("The `fullscreen` feature not being allowed, or full-screen mode not being supported");
			return true;
		}

		return false;
	}

	gantt.expand = function () {
		if(cantFullscreen()){
			return;
		}

		if (!gantt.callEvent("onBeforeExpand", []))
			return;
		var element = document.body;

		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element.msRequestFullscreen) {
			element.msRequestFullscreen();
		} else if (element.mozRequestFullScreen) {
			element.mozRequestFullScreen();
		} else if (element.webkitRequestFullscreen) {
			element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
		}
	};

	gantt.collapse = function () {
		if(cantFullscreen()){
			return;
		}

		if(!isExpanded()){
			return;
		}

		if (!gantt.callEvent("onBeforeCollapse", []))
			return;

		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		}
	};

})();